
import { QuizContentContext } from './Context';
import { useFetchData } from '../../services/useFetchData.service';
import { Spinner } from '../../components/Spinner/Spinner';
import { useEffect, useRef, useState } from 'react';
import { getDataUrl } from '../../utils/getDataUrl';

export const QuizContentProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const isLoaded = useRef(false);
  const dataUrl = getDataUrl('Quiz.json')
  const { data: fetchedData, error: fetchError } = useFetchData(dataUrl);

  useEffect(() => {
    if (isLoaded.current) return;

    if (fetchedData) {
      setData(fetchedData);
      isLoaded.current = true;
    }

    if (fetchError) {
      console.error('Error loading quiz data:', fetchError);
    }
  }, [fetchedData, fetchError]);

  if (!data) {
    return <Spinner />;
  }
  return (
    <QuizContentContext.Provider value={{ data }}>
      {children}
    </QuizContentContext.Provider>
  );
};
